<template>
	<div class="wrap">
		<b-navbar id="nav" type="dark" fixed="top" toggleable="lg" class="nav-active" :style="{background: $route.path=='/prizeweek/index' ? '#11206f' : '#000000'}">
			<b-container>
				<b-navbar-brand href="/">
                     <div :style="{'width': '16rem', 'height': '2.4rem','background':'url('+ logoUrl +') 0% 0% / 60% 100%  no-repeat', 'background-size': '90% 100%' } " />
                    </b-navbar-brand>
				<b-navbar-toggle @click="toggleClick" target="nav-collapse"></b-navbar-toggle>
				<b-collapse id="nav-collapse" is-nav>
					<b-navbar-nav class="ml-auto">
						<template
							v-for="(item, index) in menu"
						>
							<template v-if="item.submenu">
								<b-nav-item-dropdown  @click.native="navigato(item.path)"  right :key="index">
									<template  slot="button-content">
										<span @click.stop.native="linkto(subItem.path)">{{ getTitle(item.text) }}</span>
									</template>
									<b-dropdown-item
										v-for="(subItem,
										subIndex) in item.submenu"
										:key="subIndex"
										@click.stop.native="linkto(subItem.path)"
										>{{ subItem.text }}
									</b-dropdown-item>
								</b-nav-item-dropdown>
							</template>
							<template v-else>
								<b-nav-item :key="index" @click="goto(item.path, item.mao)">{{ getTitle(item.text) }}</b-nav-item>
							</template>
						</template>
                        <b-nav-item  @click="changeLanguage">{{$t('lang.lang')}}</b-nav-item >
					</b-navbar-nav>
				</b-collapse>
			</b-container>
		</b-navbar>
		<router-view />
	</div>
</template>
<script>
export default {
    inject: ['reload'], //注入reload方法
	data() {
		return {
            scrollTop: 0,
            searchShow: false,
            flag: false,
            logoUrl: '',
			menu: [
				{
					text: 'agenda',
                    path: '/prizeweek/oldVersion',
                    mao: '#agenda'
                },
                {
					text: 'academic',
                    path: '/prizeweek/oldVersion',
                    mao: '#academic_guidance'
                },
                {
					text: 'gegistration',
                    path: '/prizeweek/oldVersion',
                    mao: '#registration_for_the_conference'
                },
                {
					text: 'partners',
                    path: '/prizeweek/oldVersion',
                    mao :'#partners'
                },
                {
					text: 'live',
                    path: '/prizeweek/video',
                },
                {
					text: 'legacy',
                    path: '/prizeweek/legacy',
                },
                {
					text: 'volunteer',
                    path: '/prizeweek/volunteer',
                },
                {
					text: 'contact',
                    path: '/prizeweek/index',
                    mao: '#contact'
                },
            ],
            langFlag: false
		}
    },
    created(){
        console.log(456465)
        localStorage.getItem('LANG') == 'cn' || !localStorage.getItem('LANG')
			? ((this.$i18n.locale = 'cn'), (this.langFlag = false))
			: ((this.$i18n.locale = 'en'), (this.langFlag = true))
        this.$cookie.setCookie('BIGWEEKINDEX', this.$route.query.index)
    },
    
    watch:{
        $route:{
            handler(){
                this.getBigAwardYearId()
                 if(this.$route.query.index ==0){
                    this.menu.forEach((item ,index)=>{
                        if(index < 4) {
                            item.path = '/prizeweek/index'
                        }
                    })
                    console.log('ddd', this.menu)
                }
            },
            immediate: true
        }
    },
	mounted(){
        window.addEventListener('scroll',this.handleScroll,true)
        document.addEventListener('click', (e) => {
            if(e.target.className.baseVal == 'bi-search b-icon bi text-light' || e.target.className=='sinputc'){
                this.searchShow = true
            }else{
                this.searchShow = false
            }
        })
    },
    destroyed() {
		this.langFlag
			? localStorage.setItem('LANG', 'en')
			: localStorage.setItem('LANG', 'cn')
	},
	methods: {
        getLogo(id){
            this.$api.getLogo({
                projectId: id
            }).then(res=>{
                this.logoUrl = res.data[0].logo
            })
        },
        goto(path, mao){
            if(path == this.$route.path){
                this.$tools.goAnchor(mao);
                return false;
            }
            this.$router.push({path: path});
        },
        getTitle(title){
            let str = 'lang.'+title;
            return this.$t(str);
        },
        search(){
            this.searchShow = !this.searchShow;
        },
        changeLanguage(){
           	this.langFlag = !this.langFlag
			if (this.langFlag) {
                this.$i18n.locale = 'en'
				localStorage.setItem('LANG', 'en')
			} else {
				localStorage.setItem('LANG', 'cn')
                this.$i18n.locale = 'cn'
			}
            this.reload()
        },
        getBigAwardYearId() {
			this.$api.getBigAwardYearId().then((res) => {
				let arr = res.data;
                let weekIndex = this.$cookie.getCookie('BIGWEEKINDEX')
				this.$router.push({
                    path: this.$route.path, 
                    query: { 
                        index: weekIndex,
                        year: arr[weekIndex].id
                    }
                })
                this.getLogo(arr[weekIndex].id)
                this.$store.state.bigTitle = arr[weekIndex].name
			})
		},
		handleScroll(){
            this.scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        },
		navigato(path) {
			this.$router.push(path)
		},
		linkto(path) {
			this.$router.push(path)
        },
        toggleClick(){
            this.flag = !this.flag
        }
	},
}
</script>
<style lang="scss" scoped >

#nav {
	padding: 1rem;
}

.search-input{
    display: flex;
    align-items: center;
    position: absolute;
    top: 3rem;
    right: -1rem;
    height: 2rem;
    line-height: 2rem;
    border: 1px solid #fff;
    border-radius: 10px;
    padding: 0 1rem;
    font-size: 1rem;
    
}
.navlogo{
    position: relative;
    top: 0rem;
    width: 14rem;
    height: 3.2rem;
    left: -4rem;
}
.navlogorouter{
    position: relative;
    width: 10rem;
}
.mini-input{
    border: 1px solid #fff;
    display: flex;
    align-items: center;
    border-radius: 0.4rem;
}

.search-flag{
    position: relative;
    display: none;
    /* visibility: hidden; */
}

.input-fixed{
    top: 0rem;
    right: -1rem;
    background: #000;
}

input{
    color: #fff;
}

input::-webkit-input-placeholder {
    color: #fff;
}
.nav-active{
    background: #000;
}



.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
	color: #cfaf75 !important;
}

.navbar-dark .navbar-nav .nav-link {
	color: #ffffff !important;
}

.navbar-dark .navbar-toggler {
    color: #ffffff;
    border-color: transparent;
}



.dropdown-menu {
	border-radius: 0 !important;
}

.dropdown-item:hover,
.dropdown-item:focus {
	color: #cfaf75 !important;
	background-color: #ffffff !important;
}

/* >= 992 */

@media (min-width: 992px){  
    .search-flag{
        display: inline;
       /* visibility: visible; */
    }
    .mini-input{
        display: none;
    }
    .dropdown:hover > .dropdown-menu {
        display: block;
    }

    .dropdown > .dropdown-toggle:active {
        pointer-events: none;
    }
    .dropdown > .dropdown-toggle::after {
        border: none;
    }
    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
    }
}


</style>
